import { Component, AfterViewInit } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { BsModalRef } from 'ngx-bootstrap/modal';

import { CivilSearchService } from './../civil-search.service';
import { EventService } from './../../shared/event.service';

@Component({
  selector: 'app-civil-disclaimer',
  templateUrl: './civil-disclaimer.component.html',
  styleUrls: ['./civil-disclaimer.component.less']
})
export class CivilDisclaimerComponent implements AfterViewInit {

  userStep = 'initial';
  private userChoiceSource = new Subject<boolean>();
  userChoice$: Observable<boolean> = this.userChoiceSource.asObservable();
  searchRecordLastUpdateDate: string;

  constructor(private bsModalRef: BsModalRef,
              private eventService: EventService,
              private civilSearchService: CivilSearchService) {
    this.getSearchRecordLastUpdateDate();   // load the last update date

    // handle session time out on the disclaimer modal
    this.eventService.sessionTimedOut$.subscribe(() => {
      this.cancel();
    });
  }

  ngAfterViewInit(): void {
    this.eventService.focusField('civil-disclaimer-div');
  }

  yes() {
    this.userChoiceSource.next(true);
  }

  cancel() {
    this.userChoiceSource.next(false);
    this.bsModalRef.hide();
  }

  goToVcapInstructions() {
    this.userStep = 'vcap';
  }

  /**
   * get the last update date and notity of it through event service
   */
  getSearchRecordLastUpdateDate() {
    this.civilSearchService.getSearchRecordLastUpdateDate()
    .subscribe(lastUpdateDate => {
       this.searchRecordLastUpdateDate = lastUpdateDate;
    });
  }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/civil/civil-disclaimer/civil-disclaimer.component.ts